import type { NoteColor } from "../types"

export interface NoteColorOption {
  id: NoteColor
  label: string
}

export const NOTE_COLOR_OPTIONS: NoteColorOption[] = [
  { id: "blue", label: "Blue" },
  { id: "emerald", label: "Emerald" },
  { id: "amber", label: "Amber" },
  { id: "rose", label: "Rose" },
  { id: "purple", label: "Purple" },
]
